import React from 'react';
import { InlineMultiSelectCell } from './InlineMultiSelectCell';
import PublishedInLinksCell from './PublishedInLinksCell';
import { PropertiesList } from '../../models/propertyModel';

type Props = {
  property: PropertiesList;
  setEditableProperties: React.Dispatch<React.SetStateAction<PropertiesList[]>>;
  handleSavePropertyField: (propertyId: string, field: string, value: any) => void;
};

const PublishedInSection: React.FC<Props> = ({
  property,
  setEditableProperties,
  handleSavePropertyField,
}) => {
  let publishedArray: { name: string; url: string }[] = [];
  if (property.published_in) {
    try {
      const arr = JSON.parse(property.published_in);
      if (Array.isArray(arr)) {
        publishedArray = arr;
      } else {
        throw new Error();
      }
    } catch {
      publishedArray = property.published_in
        .split(',')
        .map(name => name.trim())
        .filter(Boolean)
        .map(name => ({ name, url: '' }));
    }
  }

  const publishedInJson = JSON.stringify(publishedArray);

  const publishedNames = publishedArray.map(item => item.name);

  const publishedUrls: { [key: string]: string } = {};
  publishedArray.forEach(item => {
    publishedUrls[item.name] = item.url;
  });

  return (
    <>
      <PublishedInLinksCell
        publishedIn={publishedInJson}
        propertyId={property.id}
        handleSavePropertyField={handleSavePropertyField}
      />
    </>
  );
};

export default PublishedInSection;